// extracted by mini-css-extract-plugin
module.exports = {"priceLabelsInLocations":"PriceLabelsInLocations_priceLabelsInLocations__1ZWgi"};